import { schema, normalize } from 'normalizr';
import { createActions, asyncAction } from '../helpers/redux';
// import { push } from 'react-router-redux';
// import {List} from 'immutable';
// import flatten from 'lodash/flatten';
// import uniq from 'lodash/uniq';
// import Partitioner from '../shared/algorithms/partitioner';

// import element2Schema from '../schemas/element';

// function generateSlug(entity) {
//   return entity.element_id; //+ '-' + entity.view_id;
// }

const tagSchema = new schema.Entity('tags');

const objectTagsSchema = new schema.Entity(
  'objectTags',
  {
    tag: tagSchema,
  },
  {
    idAttribute: tag => {
      return `${tag.taggable_id}-${tag.taggable_type}-${tag.tag_id}`;
    },
  },
);
const elementSchema = new schema.Entity('elements', {
  type: elementTypeSchema,
  relationships: [relationshipSchema],
  objectTags: [objectTagsSchema],
});
// const viewElementSchema = new schema.Entity('viewElements', {
//   element: elementSchema,
// }, { idAttribute: generateSlug });
const elementTypeSchema = new schema.Entity('types');
const relationshipSchema = new schema.Entity('relationships', {
  type: relationshipTypeSchema,
  producer: elementSchema,
  consumer: elementSchema,
});
const relationshipTypeSchema = new schema.Entity('types');
const userSchema = new schema.Entity('users');

const viewSchema = new schema.Entity('views', {
  elements: [elementSchema],
  user: userSchema,
});

// relationshipSchema.define({
//   type: relationshipTypeSchema,
//   producer: elementSchema,
//   consumer: elementSchema
// });

// elementSchema.define({
//   type: elementTypeSchema,
//   relationships: [relationshipSchema]
// });

// viewSchema.define({
//   elements: [elementSchema],
//   user: userSchema
// });

// viewElementSchema.define({
//   element: elementSchema
// });

export const ViewActions = createActions({
  @asyncAction()
  async getView(viewId) {
    return ({ client }) => {
      return client.get(`/views/${viewId}`).then(function(response) {
        return normalize(response, viewSchema);
      });
    };
  },

  // @asyncAction()
  // async removeViewElement(viewId, viewElementId){
  //   return ({dispatch, client, getState}) => {
  //     return client.delete(`/views/${viewId}/element/${viewElementId}`).then((response) => {
  //       dispatch(ViewActions.clientRemoveViewElements(viewElementId))

  //       response['id'] = viewElementId;
  //       return response;
  //     });
  //   }
  // },

  setSelectedCellTaskDSM(viewId, producer, consumer, multi) {
    return {
      viewId,
      producer,
      consumer,
      multi,
    };
  },

  setSelectedCellTaskDSMBulk(viewId, relArray) {
    return {
      viewId,
      relArray,
    };
  },

  @asyncAction()
  async tagDefaultCycles(flattenedOutput, projectId, cycles) {
    return ({ dispatch, client, getState }) => {
      return client
        .patch('/elements/bulk', {
          body: {
            flattenedOutput,
            projectId,
            cycles,
          },
        })
        .then(function(response) {
          if (!response.elements.length) return {};

          const elements = normalize(response.elements, [elementSchema]);

          return {
            elements,
          };
        });
    };
  },

  setSelectedCell(viewId, producer, consumer, multi) {
    return {
      viewId,
      producer,
      consumer,
      multi,
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/view.js